import { AnyAction } from "redux";
import { User } from "oidc-client";

export interface OidcAuthState {
    user?: User | null;
    isLoadingUser: boolean;
}

const initialState: OidcAuthState = {
    user: null,
    isLoadingUser: true
};

const SET_USER = "OIDC/SET_USER";
const CLEAR_USER = "OIDC/CLEAR_USER";
const SET_LOADING = "OIDC/SET_LOADING";

export const setOidcUser = (user: User | null) => ({ type: SET_USER, payload: user });
export const clearOidcUser = () => ({ type: CLEAR_USER });
export const setOidcLoading = (isLoading: boolean) => ({ type: SET_LOADING, payload: isLoading });

export const oidcAuthReducer = (state: OidcAuthState = initialState, action: AnyAction): OidcAuthState => {
    switch (action.type) {
        case SET_USER:
            return { ...state, user: action.payload, isLoadingUser: false };
        case CLEAR_USER:
            return { ...state, user: null, isLoadingUser: false };
        case SET_LOADING:
            return { ...state, isLoadingUser: action.payload };
        default:
            return state;
    }
};
